import { Group, DirectionalLight } from "three";
import { mainScene } from "../mainScene";
class LightService {
    constructor() {
        this.defaultLightGroup = new Group();
        mainScene.add(this.defaultLightGroup);
        this.createDefaultLights();
    }
    enableDefaultLight(enable) {
        this.defaultLightGroup.visible = enable;
    }
    createDefaultLights() {
        this.createSun();
    }
    createSun() {
        // White directional light at half intensity shining from the top
        const directionalLight = new DirectionalLight(0xffffff, 1);
        directionalLight.position.set(100, 50, -30);
        directionalLight.castShadow = true;
        const d = 40;
        directionalLight.shadow.camera.left = -d;
        directionalLight.shadow.camera.right = d;
        directionalLight.shadow.camera.top = d;
        directionalLight.shadow.camera.bottom = -d;
        directionalLight.shadow.camera.far = 3500;
        directionalLight.shadow.bias = -0.0001;
    }
}
export const lightService = new LightService();
